export enum type {
    GET_TEACHER_VIDEO_LIST = 'GET_TEACHER_VIDEO_LIST',
    GET_TEACHER_VIDEO_LIST_ASYNC = 'GET_TEACHER_VIDEO_LIST_ASYNC',
}
